import type { SVGMotionProps } from 'motion/react'
import { motion } from 'motion/react'

export const House = ({
  isHovered,
  ...props
}: SVGMotionProps<SVGSVGElement> & { isHovered?: boolean }) => {
  return (
    <motion.svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      whileHover="hover"
      animate={isHovered ? 'hover' : undefined}
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.301}
        d="M3.327 6.976v8.175c0 .934 0 1.401.182 1.758.16.314.415.57.729.73.357.181.824.181 1.758.181h8.008c.934 0 1.401 0 1.758-.182.314-.16.57-.415.73-.729.181-.357.18-.824.18-1.758V6.976"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.301}
        d="m1.659 8.227 7.54-5.655c.287-.215.43-.323.589-.365a.835.835 0 0 1 .424 0c.158.042.302.15.589.365l7.54 5.655M3.327 6.977l5.071-3.804c.575-.431.862-.647 1.177-.73.279-.073.571-.073.85 0 .315.083.602.299 1.177.73l5.071 3.803"
      />
      <motion.g
        transition={{ duration: 0.2, ease: 'easeOut' }}
        initial={{ scale: 1 }}
        variants={{ hover: { scaleY: 1.15, y: '-15%' } }}
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.301}
          d="M7.497 17.82v-4.528c0-.343 0-.514.091-.645a.763.763 0 0 1 .364-.268c.179-.066.412-.066.879-.066h2.333c.467 0 .7 0 .878.066a.763.763 0 0 1 .365.268c.09.13.09.302.09.645v4.528"
        />
        <motion.path
          transition={{ duration: 0.3, ease: 'easeOut' }}
          initial={{ x: 0 }}
          variants={{ hover: { x: -5 } }}
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.301}
          d="M12.497 13.064v4.756"
        />
      </motion.g>
    </motion.svg>
  )
}
